module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали заявки\n    "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'claim-edit',
        params: {
          id: _vm.claim.id
        }
      }
    }
  }, [_vm._v("Редактировать информацию")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'claims'
      }
    }
  }, [_vm._v("← Назад к Заявкам")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Клиент")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.claim.full_name))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Текст заявки")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.claim.text))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Дата и время")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.claim.datetime)))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2934d4aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claim/ClaimDetails.vue
// module id = 609
// module chunks = 0